import request from '@/utils/request'

// 回传配置列表
export function echoConfigurationList(params = {}) {
  return request({
    url: '/return_ploy/py_callback',
    method: 'get',
    params
  })
}

// 创建回传策略
export function createEchoPolicy(data = {}) {
  return request({
    url: '/return_ploy/py_callback',
    method: 'post',
    data
  })
}

// 修改回传策略
export function modifyTheReturnPolicy(data = {}) {
  return request({
    url: `/return_ploy/py_callback/${data.id}`,
    method: 'put',
    data
  })
}

// 删除回传策略
export function deleteTheReturnPolicy(data = {}) {
  return request({
    url: `/return_ploy/py_callback/${data.id}`,
    method: 'DELETE',
    data
  })
}

// 回传策略详情
export function returnPolicyDetails(params = {}) {
  return request({
    url: `/return_ploy/py_callback/${params.id}`,
    method: 'get',
    params
  })
}
// 广告回传配置删除
export function backRuleAdmindelete(data) {
  return request({
    url: '/backRule/delete',
    method: 'post',
    data
  })
}
// 广告回传配置
export function backRuleAdminlist(params = {}) {
  return request({
    url: '/backRule/list',
    method: 'get',
    params
  })
}
// 广告回传配置更新
export function backRuleAdminupdate(data) {
  return request({
    url: '/backRule/update',
    method: 'post',
    data
  })
}
// 广告回传配置新增
export function backRuleAdmincreate(data) {
  return request({
    url: '/backRule/create',
    method: 'post',
    data
  })
}
export function editAppIdsLink(data = {}) {
  return request({
    url: '/backRule/bind',
    method: 'post',
    data
  })
}
// 账号报表监测通知
export function authuserliust(params = {}) {
  return request({
    url: '/ocean/auth_user/list',
    method: 'get',
    params
  })
}
export function authuserupdatemonitorreport(data = {}) {
  return request({
    url: '/ocean/auth_user/update_monitor_report',
    method: 'post',
    data
  })
}
export function authuserupdatemonitorreportiwew(data = {}) {
  return request({
    url: '/adx/task/kafka/operate',
    method: 'post',
    data
  })
}
// 获取鉴权 URL
export function dingdingauthurl(params = {}) {
  return request({
    url: '/casdoor/dingding/auth-url',
    method: 'get',
    params
  })
}
// 拉取广告主
export function pullAdvertiserList(data = {}) {
  return request({
    url: '/ocean/auth_user/pull_advertiser',
    method: 'post',
    data
  })
}
